import { makeAutoObservable } from 'mobx'
import { mainStore } from '@/domains/Account/store'
import { MktuClassStore } from '@/store/Mktu/MktuClass'

export class MktuManualSelectStore {
  /**
   * Флаг, указывающий, включен ли режим отображения подробной
   * информации о классах
   */
  isModeClassesDetailsEnabled = false

  /**
   * Номер класса, для которого отображается информация
   */
  visibleInfoClassNumber: MktuClassStore['number'] | null = null

  /**
   * Номер класса, для которого отображается подробная информация
   */
  mktuClassNumberForDetails = null

  /**
   * Массив выбранных классов
   */
  selected = []

  /**
   * Получение класса для отображения подробной информации
   */
  get mktuClassForDetails() {
    return this.mktuClassNumberForDetails != null
      ? mainStore.mktuClassesList.getByClassNumber(
          this.mktuClassNumberForDetails
        )
      : null
  }

  /**
   * Конструктор класса
   */
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  /**
   * Установка номера класса, для которого отображается информация
   * @param value - Номер класса
   */
  setVisibleInfoClassNumber(value: MktuClassStore['number'] | null) {
    this.visibleInfoClassNumber = value
  }

  private _resetMktuClasNumberTimerId = null

  /**
   * Отображение информации о классе
   * @param mktClassNumber - Номер класса
   */
  showMktuClassInfo(mktClassNumber) {
    if (this._resetMktuClasNumberTimerId != null) {
      clearTimeout(this._resetMktuClasNumberTimerId)
      this._resetMktuClasNumberTimerId = null
    }
    this.setVisibleInfoClassNumber(mktClassNumber)
  }

  /**
   * Скрытие информации о классе
   */
  hideMktuClassInfo() {
    if (this._resetMktuClasNumberTimerId != null) {
      clearTimeout(this._resetMktuClasNumberTimerId)
      this._resetMktuClasNumberTimerId = null
    }
    this._resetMktuClasNumberTimerId = setTimeout(() => {
      this.setVisibleInfoClassNumber(null)
    }, 300)
  }

  /**
   * Отображение подробной информации о классе
   * @param value - Номер класса
   */
  showMktuClassDetails(value) {
    this.mktuClassNumberForDetails = value
  }

  /**
   * Скрытие подробной информации о классе
   */
  hideMktuClassDetails() {
    this.mktuClassNumberForDetails = null
  }

  /**
   * Выбор класса по номеру
   * @param value - Номер класса
   */
  selectByClassNumber(value: MktuClassStore['number']) {
    if (this.selected.includes(value)) {
      this.selected = this.selected.filter((v) => v !== value)
    } else {
      this.selected = [...this.selected, value]
    }
  }

  /**
   * Выбор класса
   * @param value - Класс
   */
  select(value: MktuClassStore) {
    this.selectByClassNumber(value.number)
    this.setMktuClassNumberForDetails(null)
  }

  /**
   * Выбор всех классов
   */
  selectAll() {
    this.selected = []
  }

  setSelected(values) {
    this.selected = values
  }

  /**
   * Установка номера класса, для которого отображается подробная информация
   * @param value - Номер класса
   */
  setMktuClassNumberForDetails(value: MktuClassStore['number']) {
    this.mktuClassNumberForDetails = value
  }

  /**
   * Переключение режима отображения подробной информации о классах
   */
  toggleModeClassesDetails() {
    this.isModeClassesDetailsEnabled = !this.isModeClassesDetailsEnabled
  }

  /**
   * Отключение режима отображения подробной информации о классах
   */
  disableModeClassesDetails() {
    this.isModeClassesDetailsEnabled = false
  }
}
